<template>
<div id="statsif" class="right-content">

  <el-form :model="filters" class="head-form">
    <el-row type="flex" justify="center" :gutter="20">
      <el-col :xs="6" :sm="6" :md="6" :lg="4">
          <el-form-item prop="event">
            <el-select v-model="filters.event" clearable placeholder="全部" @change="handleEventChange">
              <el-option
                v-for="item in formatEvent"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- <el-col :span="8" :offset="2"> -->
        <el-col :xs="16" :sm="16" :md="16" :lg="10">
          <el-form-item prop="category">
            <el-date-picker
              v-model="filters.daterange"
              type="daterange"
              align="right"
              placeholder="选择日期范围"
              @change="handleDateRangeChange"
              :picker-options="pickerOptions2">
            </el-date-picker>
          </el-form-item>
        </el-col>

    </el-row>

  </el-form>

    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="24" :md="22" :lg="14" class="el-item shadow">

      <el-card :body-style="{ padding: '0px' }">
        <div id="ifcharts" ref="ifcharts" class="ifchart-wrap"
          v-show="getStatsDataLen"
          element-loading-text="玩命加载中..."></div>
      </el-card>

      <el-card :body-style="{ padding: '0px' }" style="margin-top: .3rem">
      <el-table
        :data="formatEventData"
        v-loading="getLoadingStatus"
        element-loading-text="玩命加载中..."
        stripe
        style="width: 100%"
        max-height="400">
        <el-table-column
          prop="date"
          label="日期"
          width="180">
        </el-table-column>
        <el-table-column
          prop="appid"
          label="appid"
          width="100">
        </el-table-column>
        <el-table-column
          prop="list"
          label="list"
          min-width="100">
        </el-table-column>
        <el-table-column
          prop="search"
          label="search"
          min-width="100">
        </el-table-column>
      </el-table>
      </el-card>

    </el-col>
  </el-row>

</div>
</template>

<script type="text/javascript">
/**
 * 销售数据概览页组件
 */
import {mapGetters, mapActions} from 'vuex';
import { getNowTime, routeMap } from '../../utils/com.js'
import '../../static/style/stats/interface.scss'
import { eventType, headerOption } from '../../config/config'
import { Loading } from 'element-ui';
import echarts from 'echarts'


export default {
    data() {
        return {
            pickerOptions2: {
              disabledDate(time) {
                return time.getTime() > Date.now();
              },
              shortcuts: [{
                text: '最近一周',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近一个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近三个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                  picker.$emit('pick', [start, end]);
                }
              }]
            },
            filters: {
                event: '',
                daterange: '',
                start: '',
                end: '',
            },
            newloading: false,
            show: true,
            currentDate: new Date(),
            date: getNowTime(),
            page: 1,
            limit: 10,
            clientid: 1,
            setOption: {

              title: {
                  text: 'list & search 接口调用频率',
                  subtext: '',
                  x: 'center'
              },
              tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                      animation: false
                  }
              },
              legend: {
                  data:['list','search'],
                  x: 'left'
              },
              toolbox: {
                  feature: {
                      dataZoom: {
                          yAxisIndex: 'none'
                      },
                      restore: {},
                      saveAsImage: {}
                  }
              },
              axisPointer: {
                  link: {xAxisIndex: 'all'}
              },
              dataZoom: [
                  {
                      show: true,
                      realtime: true,
                      start: 0,
                      end: 100,
                      xAxisIndex: [0, 1]
                  },
                  {
                      type: 'inside',
                      realtime: true,
                      start: 0,
                      end: 100,
                      xAxisIndex: [0, 1]
                  }
              ],
              grid: [{
                  left: 50,
                  right: 50,
                  height: '35%'
              }, {
                  left: 50,
                  right: 50,
                  top: '55%',
                  height: '35%'
              }],
              xAxis : [
                  {
                      type : 'category',
                      boundaryGap : false,
                      axisLine: {onZero: true},
                      data: null
                  },
                  {
                      gridIndex: 1,
                      type : 'category',
                      boundaryGap : false,
                      axisLine: {onZero: true},
                      data: null,
                      position: 'top',
                      show: false
                  }
              ],
              yAxis : [
                  {
                      name : 'list(time/h)',
                      type : 'value',
                      // max : 500
                  },
                  {
                      gridIndex: 1,
                      name : 'search',
                      type : 'value',
                      inverse: true
                  }
              ],
              series : [
                  {
                      name:'list',
                      type:'line',
                      symbolSize: 8,
                      hoverAnimation: false,
                      data:null
                  },
                  {
                      name:'search',
                      type:'line',
                      xAxisIndex: 1,
                      yAxisIndex: 1,
                      symbolSize: 8,
                      hoverAnimation: false,
                      data: null
                  }
              ]
            }
            // date: new Date().format("yyyy-MM-dd")
        }
    },
    created() {

      var that = this;
      let param = {
        appid: this.filters.event,
        start: this.filters.start,
        end: this.filters.end,
      }
      console.debug("created> getConsoleApi> param:%o", param);
      this.updateLoadingStatus(true);
      this.getConsoleApi(param).then(
        (resp) => {
          this.updateLoadingStatus(false);
          console.debug("created> getConsoleApi> resp:%o", resp);
          if(resp && resp.code !== 0){
            that.$message({
                  message: resp.msg,
                  type: 'error'
              });
          }else{
            this.handleDataChange();


            // let lists = [];
            // // console.debug("formatEventData> statsdata:%o", this.statsdata);
            // for(let i in this.apidata){
            //   let l = {};
            //   let newdata = this.apidata[i];
            //   // console.debug("formatEventData> newdata:%o", newdata);
            //   l.id = newdata.id || 0;
            //   l.date = newdata.date || '';
            //   l.appid = newdata.appid || '';
            //   l.list = newdata.list || '';
            //   l.search = newdata.search || '';
            //   // console.debug("formatEventData> newsData:%o, ls:%o", newdata, ls);
            //   lists.push(l);
            // }
            // // quick sort array
            // console.debug("formatEventData> before sort> lists:%o", lists);
            // for (let i = 1; i < lists.length; i++) {
            //     let key = lists[i];
            //     let j = i - 1;
            //     while (j >= 0 && new Date(lists[j].date).getTime()/1000 > new Date(key.date).getTime()/1000) {
            //         // console.debug("formatEventData> j:%o, lists[%o]:%o, lists[%o]:%o", j, j+1, lists[j + 1], j, lists[j]);
            //         lists[j + 1] = lists[j];
            //         // console.debug("formatEventData> j:%o, switch lists[%o]:%o, lists[%o]:%o", j, j+1, lists[j + 1], j, lists[j]);
            //         j--;
            //     }
            //     lists[j + 1] = key;
            // }

            // console.debug("showDiag> after sort> lists:%o", lists);
            // let _legendData = [], _legendData1 = [], _legendData2 = []
            // for (let i in lists) {
            //     console.debug("showDiag> i:%o, list", i, lists[i]);
            //     _legendData.push(lists[i].date.replace('2017-', ''));
            //     _legendData1.push(lists[i].list);
            //     _legendData2.push(lists[i].search);
            // }
            // console.debug("showDiag> _legendData:%o", _legendData);
            // this.setOption.xAxis[0].data = _legendData
            // this.setOption.xAxis[1].data = _legendData
            // this.setOption.series[0].data = _legendData1
            // this.setOption.series[1].data = _legendData2
            // console.debug("getNewStatis> setOption:%o, ifcharts:%o", this.setOption,
            // ifcharts);
            // let myChart = echarts.init(document.getElementById('ifcharts')) //this.$refs.ifcharts)
            // console.debug("getNewStatis> setOption:%o", that.setOption);
            // myChart.setOption(that.setOption)

            // console.debug("formatEventData> lists:%o", lists);


          }

        }
      );


    },
    mounted() {
        console.debug("mounted");
    },
    computed: {
        ...mapGetters({
            // 映射 this.statsdata 为 store.getters.statsdata
            eventdata: 'eventdata',
            eventtotal: 'eventtotal',
            loadingStatus: 'loadingStatus',
            apidata: 'apidata',
            appidlist: 'appidlist',
            apitotal: 'apitotal',
            getLoadingStatus: 'getLoadingStatus'
        }),
        getStatsDataLen: function() {
            console.debug("getStatsDataLen> eventdata.length:%o", this.eventdata.length);
            return this.apidata.length;
        },
        formatEvent(){
          let typelists = [];
          for(let i in this.appidlist){
            let typelist = {}
            typelist.value = this.appidlist[i];//i;
            typelist.label = this.appidlist[i];
            typelists.push(typelist);
          }
          console.debug("formatEvent> typelists:%o", typelists);
          return typelists;
        },
        formatEventData: function () {
              // `this` points to the vm instance
              let lists = [];
              // console.debug("formatEventData> statsdata:%o", this.statsdata);
              for(let i in this.apidata){
                let l = {};
                let newdata = this.apidata[i];
                // console.debug("formatEventData> newdata:%o", newdata);
                l.id = newdata.id || 0;
                l.date = newdata.date || '';
                l.appid = newdata.appid || '';
                l.list = newdata.list || '';
                l.search = newdata.search || '';
                // console.debug("formatEventData> newsData:%o, ls:%o", newdata, ls);
                lists.push(l);
              }
              // quick sort array
              console.debug("formatEventData> before sort> lists:%o", lists);
              for (let i = 1; i < lists.length; i++) {
                  let key = lists[i];
                  let j = i - 1;
                  while (j >= 0 && new Date(lists[j].date).getTime()/1000 > new Date(key.date).getTime()/1000) {
                      // console.debug("formatEventData> j:%o, lists[%o]:%o, lists[%o]:%o", j, j+1, lists[j + 1], j, lists[j]);
                      lists[j + 1] = lists[j];
                      // console.debug("formatEventData> j:%o, switch lists[%o]:%o, lists[%o]:%o", j, j+1, lists[j + 1], j, lists[j]);
                      j--;
                  }
                  lists[j + 1] = key;
              }
              console.debug("formatEventData> lists:%o", lists);
              return lists;
            }
    },
    methods: {
        ...mapActions({
          // 映射 this.getEditorData() 为 this.$store.dispatch('getEditorData')
          updateLoadingStatus: 'updateLoadingStatus',
          getConsoleEvent: 'getConsoleEvent',
          getConsoleApi: 'getConsoleApi'
        }),
        handleDateRangeChange(val) {
          console.debug("handleDateRangeChange> val:%o, daterange:%o, start:%o, end:%o", val, this.filters.daterange, this.filters.start, this.filters.end);
          let datarange = val.split(' - ')
          this.filters.start = datarange[0]
          this.filters.end = datarange[1]
          console.debug("handleDateRangeChange> start:%o, end:%o", this.filters.start, this.filters.end);

          var that = this;
          let param = {
            appid: this.filters.event,
            start: this.filters.start,
            end: this.filters.end,
          }
          console.debug("created> getConsoleApi> param:%o", param);
          this.updateLoadingStatus(true);
          this.getConsoleApi(param).then(
            (resp) => {
              this.updateLoadingStatus(false);
              console.debug("created> getConsoleApi> resp:%o", resp);
              if(resp && resp.code !== 0){
                that.$message({
                      message: resp.msg,
                      type: 'error'
                  });
              }else{
                this.handleDataChange();
              }
            }
          );

        },
        handleDataChange() {
          console.debug("handleDateChange> ");
          var that = this;

          let lists = [];
          // console.debug("formatEventData> statsdata:%o", this.statsdata);
          for(let i in this.apidata){
            let l = {};
            let newdata = this.apidata[i];
            // console.debug("formatEventData> newdata:%o", newdata);
            l.id = newdata.id || 0;
            l.date = newdata.date || '';
            l.appid = newdata.appid || '';
            l.list = newdata.list || '';
            l.search = newdata.search || '';
            // console.debug("formatEventData> newsData:%o, ls:%o", newdata, ls);
            lists.push(l);
          }
          // quick sort array
          console.debug("formatEventData> before sort> lists:%o", lists);
          for (let i = 1; i < lists.length; i++) {
              let key = lists[i];
              let j = i - 1;
              while (j >= 0 && new Date(lists[j].date).getTime()/1000 > new Date(key.date).getTime()/1000) {
                  // console.debug("formatEventData> j:%o, lists[%o]:%o, lists[%o]:%o", j, j+1, lists[j + 1], j, lists[j]);
                  lists[j + 1] = lists[j];
                  // console.debug("formatEventData> j:%o, switch lists[%o]:%o, lists[%o]:%o", j, j+1, lists[j + 1], j, lists[j]);
                  j--;
              }
              lists[j + 1] = key;
          }

          // console.debug("showDiag> after sort> lists:%o", lists);
          let _legendData = [], _legendData1 = [], _legendData2 = []
          for (let i in lists) {
              // console.debug("showDiag> i:%o, list", i, lists[i]);
              _legendData.push(lists[i].date.replace('2017-', ''));
              _legendData1.push(lists[i].list);
              _legendData2.push(lists[i].search);
          }
          // console.debug("showDiag> _legendData:%o", _legendData);
          this.setOption.xAxis[0].data = _legendData
          this.setOption.xAxis[1].data = _legendData
          this.setOption.series[0].data = _legendData1
          this.setOption.series[1].data = _legendData2
          this.setOption.title.text = this.filters.event + ' 接口调用频次'
          console.debug("getNewStatis> setOption:%o", this.setOption);
          let myChart = echarts.init(document.getElementById('ifcharts')) //this.$refs.ifcharts)
          console.debug("getNewStatis> setOption:%o", that.setOption);
          myChart.setOption(that.setOption)
          console.debug("formatEventData> lists:%o", lists);

        },
        handlePageChange(val) {
          console.debug("handlePageChange> val:%o", val);
          if(this.page !== val){
            this.page = val;

          }
        },
        handleEventChange(val){
          console.debug("handleEventChange> val:%o, event:%o", val, this.filters.event);

          var that = this;
          let param = {
            appid: this.filters.event,
            start: this.filters.start,
            end: this.filters.end,
          }
          console.debug("created> getConsoleApi> param:%o", param);
          this.updateLoadingStatus(true);
          this.getConsoleApi(param).then(
            (resp) => {
              this.updateLoadingStatus(false);
              console.debug("created> getConsoleApi> resp:%o", resp);
              if(resp && resp.code !== 0){
                that.$message({
                      message: resp.msg,
                      type: 'error'
                  });
              }else{
                this.handleDataChange();
              }
            }
          );

        },
        handleHotChange(val){
          console.debug("handleHotChange> val:%o, event:%o", val, this.filters.event);

        },
    },
}
</script>



// WEBPACK FOOTER //
// interface.vue?239094f4